__turbopack_context__.v({
  "company-description": "commercialFooterStyle-module-scss-module__SBElHq__company-description",
  "footer": "commercialFooterStyle-module-scss-module__SBElHq__footer",
  "footer-bottom": "commercialFooterStyle-module-scss-module__SBElHq__footer-bottom",
  "footer-links": "commercialFooterStyle-module-scss-module__SBElHq__footer-links",
  "footer-links-container": "commercialFooterStyle-module-scss-module__SBElHq__footer-links-container",
  "footer-logo": "commercialFooterStyle-module-scss-module__SBElHq__footer-logo",
  "footer-logo-container": "commercialFooterStyle-module-scss-module__SBElHq__footer-logo-container",
  "footer-middle": "commercialFooterStyle-module-scss-module__SBElHq__footer-middle",
  "footer-top": "commercialFooterStyle-module-scss-module__SBElHq__footer-top",
  "item": "commercialFooterStyle-module-scss-module__SBElHq__item",
  "social-column": "commercialFooterStyle-module-scss-module__SBElHq__social-column",
  "socials": "commercialFooterStyle-module-scss-module__SBElHq__socials",
});
